import React from 'react';

interface Props {
  variant: 'card' | 'mini' | 'bar';
  onUnlock: () => void;
  message?: string;
}

/**
 * The paywall gate.
 *
 * This renders INSTEAD of paid content, never on top of it — the server omits
 * the paid fields entirely, so there is nothing underneath to blur. If you
 * ever find yourself adding a CSS blur here, the payload is leaking.
 */
const FitGate: React.FC<Props> = ({ variant, onUnlock, message }) => {
  if (variant === 'bar') {
    return (
      <div className="fr-stickybar">
        <div className="fr-stickybar__text">
          <b>Your numbers are free. The fixes aren't.</b>
          <span>Every adjustment · why &amp; how · PDF report</span>
        </div>
        <button type="button" className="fr-btn fr-btn--pri" onClick={onUnlock}>
          Unlock the full plan
        </button>
      </div>
    );
  }

  if (variant === 'mini') {
    return (
      <div className="fr-gate fr-gate--mini">
        <p className="fr-gate__body">
          {message ?? 'The reasoning and the steps come with the full plan.'}
        </p>
        <button type="button" className="fr-btn fr-btn--sec" onClick={onUnlock}>
          Unlock
        </button>
      </div>
    );
  }

  return (
    <div className="fr-gate">
      <h3 className="fr-gate__title">Your full fit plan</h3>
      <p className="fr-gate__body">
        {message ??
          "Step-by-step adjustments, what to expect after each one, and every other change we'd make."}
      </p>
      <button type="button" className="fr-btn fr-btn--pri" onClick={onUnlock}>
        Unlock the full plan
      </button>
    </div>
  );
};

export default FitGate;
